import { ResultsSummary } from './ResultsSummary';
export default ResultsSummary;
